export default {
  id: 'slack_promote_a_job',
  title: 'Promote a job',
  type: 'Direct / Channel',
  canSendToChannel: true,
  relations: [ 'JOB' ],
  description: 'Send a selected job to your employees so they can easily share it across their network.',
  body: {
    blocks: [
      {
        text: {
          text: '[[INPUT_INTRODUCTION_TEXT]]',
          type: 'mrkdwn'
        },
        type: 'section'
      },
      {
        text: {
          text: '*{{JOB_TITLE}}*',
          type: 'mrkdwn'
        },
        type: 'section'
      },
      {
        type: 'actions',
        elements: [
          {
            url: '{{JOB_LINKEDIN_SHARE_LINK}}',
            text: {
              text: 'LinkedIn',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          },
          {
            url: '{{JOB_FACEBOOK_SHARE_LINK}}',
            text: {
              text: 'Facebook',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          },
          {
            url: '{{JOB_WHATSAPP_SHARE_LINK}}',
            text: {
              text: 'Whatsapp',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          },
          {
            url: '{{JOB_TWITTER_SHARE_LINK}}',
            text: {
              text: 'Twitter',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          },
          {
            url: '{{JOB_MESSENGER_SHARE_LINK}}',
            text: {
              text: 'Messenger',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          }
        ]
      },
      {
        text: {
          text: 'Checkout possible matches among your LinkedIn connections',
          type: 'mrkdwn'
        },
        type: 'section'
      },
      {
        type: 'actions',
        elements: [
          {
            url: '{{JOB_MATCH_LINK}}',
            text: {
              text: 'LinkedIn Matches',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          },
        ]
      },
      {
        text: {
          text: 'Unsure what to send? How About:\n\n[[INPUT_SHARE_TEXT]]\n\n{{JOB_SHARE_LINK}}',
          type: 'mrkdwn'
        },
        type: 'section'
      },
    ]
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Share the following job with your network to win rewards! ...',
      defaultValue: 'Share the following job with your network to win rewards!',
      type: 'HTML'
    },
    INPUT_SHARE_TEXT: {
      label: 'Share Text',
      placeholder: 'Are you interested in working with me as a ...',
      defaultValue: 'Are you interested in working with me as a {{JOB_TITLE}}',
      type: 'HTML'
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/slack/promoteJob.js